import { Grid } from '@mui/joy';
import React, { useEffect, useState } from 'react';
import './dashboard.css';
import axios from 'axios';
import { endpoint } from '../../resource/Constant';
import { toast } from 'react-toastify';
import { Backdrop, CircularProgress } from '@mui/material';
import { useChatAuth } from './Auth/ChatAuthProvider';
export default function Home() {
  const [newApiKey, setNewApiKey] = useState('');
  const [accountInfo, setAccountInfo] = useState('');
  const [addApiKey, setAddApiKey] = useState(false);
  const [loading, setLoading] = useState(false);
  const header = { Authorization: 'Bearer ' + localStorage.getItem('adminChatauthToken') };
  const { ischatAuthenticated, chatlogout } = useChatAuth();

  const handleApiKeyChange = () => {
    if (newApiKey.length == 0) {
      return;
    }
    setLoading(true);
    const param = {
      open_api_key: newApiKey
    };
    axios
      .put(endpoint + '/api/aichatbot/addapikey', null, { headers: header, params: param })
      .then((res) => {
        toast.success(`OpenAI API Key Updated`, {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error1'
        });
        setNewApiKey('');
        getCompanyData();
        setLoading(false);
      })
      .catch((err) => {
        const error = err?.response?.data?.detail ? err?.response?.data?.detail : 'Something went wrong.';
        toast.error(`${error}`, {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error1'
        });
        setLoading(false);
      });
  };

  const getCompanyData = () => {
    setLoading(true);
    axios
      .get(endpoint + '/api/aichatbot/company', { headers: header })
      .then((res) => {
        setAccountInfo(res?.data);
        setLoading(false);
      })
      .catch((err) => {
        const error = err?.response?.data?.detail ? err?.response?.data?.detail : 'Something went wrong.';
        toast.error(`${error}`, {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error1'
        });
        setLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);
    getCompanyData();
  }, []);

  const disabledAccount = async () => {
    setLoading(true);
    axios
      .post(`${endpoint}/api/aichatbot/disableaccount`, null, {
        headers: { Authorization: `Bearer ${localStorage.getItem('adminChatauthToken')}` }
      })
      .then((res) => {
        toast.success(`${res?.data?.message}`, {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error1'
        });
        localStorage.removeItem('adminChatauthToken');
        localStorage.removeItem('chatauthToken');
        chatlogout();
        setLoading(false);
      })
      .catch((err) => {
        toast.error(`${err?.data?.message}`, {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error1'
        });
        setLoading(false);
      });
  };
  return (
    <>
      <Grid>
        <div className="dashboard-container">
          <h1 className="dashboard-title">Company Dashboard</h1>
          <div className="dashboard-details">
            <div className="info-section">
              <h2 style={{ fontFamily: 'Work Sans, Lora, Merriweather', color: '#cd143e' }}>Account Details</h2>
              <p style={{ color: 'white' }}>
                <strong>Company Name:</strong> {accountInfo?.company_name}
              </p>
              <p style={{ color: 'white' }}>
                <strong>Support Email:</strong> {accountInfo?.support}
              </p>
              <p style={{ color: 'white' }}>
                <strong style={{ color: 'white' }}>Tokens Used:</strong> {accountInfo.tokens_used}
              </p>
              <p style={{ color: 'white' }}>
                <strong style={{ color: 'white' }}>Subscription:</strong>{' '}
                {accountInfo.subcription === true
                  ? 'Subscribed'
                  : accountInfo.tokens_used >= 3000
                  ? 'Not Subscribed(Account disabled)'
                  : 'Not Subscribed'}
              </p>
            </div>

            {addApiKey ? (
              <div className="api-section">
                <h2 style={{ fontFamily: 'Work Sans, Lora, Merriweather' }}>Manage API Key</h2>
                {accountInfo.subcription === true && (
                  <h4>
                    <strong>OPEN-AI Api key:</strong> {accountInfo?.api_key}
                  </h4>
                )}
                <input
                  type="text"
                  value={newApiKey}
                  onChange={(e) => setNewApiKey(e.target.value)}
                  placeholder="Enter new API key"
                  className="api-input"
                />
                <button onClick={handleApiKeyChange} className="api-button">
                  Update
                </button>
                <button
                  onClick={() => {
                    setAddApiKey(false);
                  }}
                  style={{ marginLeft: '20px' }}
                  className="api-button"
                >
                  Cancel
                </button>
              </div>
            ) : (
              <>
                <button
                  onClick={() => {
                    setAddApiKey(true);
                  }}
                  className="api-button"
                >
                  {accountInfo.subcription ? 'Update API Key' : 'Add Api Key'}
                </button>
              </>
            )}
            <button onClick={disabledAccount} className="api-button-delete">
              Delete Account Permanently
            </button>
          </div>
        </div>
        <Backdrop open={loading}>
          <svg width={0} height={0}>
            <defs>
              <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#e01cd5" />
                <stop offset="100%" stopColor="#1CB5E0" />
              </linearGradient>
            </defs>
          </svg>
          <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} size={70} thickness={3} />
        </Backdrop>
      </Grid>
    </>
  );
}
